import { ca } from '@cian/analytics';

export const trackPopupShow = (regionName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'GeoSuggest',
    category: 'Show',
    label: `Suggest/region_${regionName}`,
  });
};

export const trackPopupClose = (regionName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'GeoSuggest',
    category: 'Close',
    label: `Select/region_${regionName}`,
  });
};

export const trackPopupAgree = (regionName: string) => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'GeoSuggest',
    category: 'Agree',
    label: `Select/region_${regionName}`,
  });
};
